import React from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './index.module.css';
import CarBoosterSeatIcon from '../../../assets/svgs/CarBoosterSeatIcon.svg';

export const AdditionalSeat = ({ record }) => {
  return record?.needsAdditionalCarSeat ? (
      <Popover
        content={record?.needsAdditionalCarSeat?.msg}
        placement='topLeft'
        overlayClassName={classNames({
          [styles.overlay]: true
        })}
        getPopupContainer={(trigger) => trigger}>
        <div >
          <img src={CarBoosterSeatIcon} width="20px" height="25px" alt="" />
        </div>
      </Popover>
    ) 

    : null;
};

AdditionalSeat.propTypes = {
  record: PropTypes.object,
};
